import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../../core/shared/service/crud/mvs-crud-mode.enum';
import {
    SpBoardTemplateObjectComponent
} from '../../../component/protected-components/sp-board-template-object-component/sp-board-template-object.component';

@Injectable({
    providedIn: 'root'
})
export class SpBoardTemplateService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/sp/boardTemplates');
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        return SpBoardTemplateObjectComponent;
    }
}
